<template>
  <div>
    <main-layout>
      <intent :showDefault="true">
        <template slot="header">
          <v-layout>
            <v-flex>
              <h3 class="headline">{{ $t('Conversation') }}</h3>
            </v-flex>
            <v-flex>
              <transfer-intent></transfer-intent>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex xs12 sm8>
              <p style="display: inline-block;">
                {{ $t('To let your Chatbot being more accurate, add more conversation') }}
              </p>
            </v-flex>
            <v-flex xs12 sm4 class="text-xs-left text-sm-right">
              <a
                target="_blank"
                href="https://blog.zwiz.ai/%E0%B8%81%E0%B8%A3%E0%B8%93%E0%B8%B5%E0%B9%84%E0%B8%AB%E0%B8%99%E0%B8%9A%E0%B9%89%E0%B8%B2%E0%B8%87%E0%B8%97%E0%B8%B5%E0%B9%88%E0%B8%97%E0%B8%B3%E0%B9%83%E0%B8%AB%E0%B9%89%E0%B8%9A%E0%B8%AD%E0%B8%97/"
              >
                <strong>*** {{ $t('Why my bot is not answer?') }}</strong>
              </a>
            </v-flex>
          </v-layout>
        </template>
      </intent>
    </main-layout>
    <!--     <v-dialog v-model="dialog"  max-width="500">
      <v-card>
        <div style="position: absolute;right: 0;">
          <v-btn icon>
            <v-icon @click="from = ''" color="grey">close</v-icon>
          </v-btn>                
        </div>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12 class="text-xs-center">
              <h5>
                {{$t(`Join our group for more informations.`)}}  
              </h5>                  
            </v-flex>
            <v-flex xs12 class="text-xs-center">
              <v-btn @click="joinGroup" color="primary" outline>{{$t('Join group')}}</v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>-->
  </div>
</template>

<script>
import Intent from './Intent'
import TransferIntent from './TransferIntent'
export default {
  components: {
    Intent,
    TransferIntent
  },
  data() {
    return {
      from: ''
    }
  },
  computed: {
    dialog() {
      // return this.from == 'Setup'
      return false
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.from = from.name
    })
  },
  methods: {
    joinGroup() {
      window.open('https://www.facebook.com/groups/zwizaigroup/', '_blank')
      this.from = ''
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/Conversation.vue